const headerStyles = (theme) => ({
  headerWrapper: {
    width: "100%",
    rounded: "8px",
    padding: "0px 16px 0px 16px",
    position: "fixed",
    top: 5,
    zIndex: 1000,
    background: "transparent",
  },

  announcementBar: {
    color: "#ffffff",
    textAlign: "center",
    padding: "10px",
    fontSize: "14px",
    fontWeight: 500,
    borderRadius: "18px 18px 1px 1px",
    marginTop: "5px",
    marginBottom: "2px",
  },

  // navbar: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  //   padding: "6px",
  //   background: "#fdf9f3",
  //   borderRadius: "1px 1px 18px 18px",
  // },

  navbar: {
    pointerEvents: "auto", // Re-enable clicks for the navbar
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 24px",

    // Glass effect
    background: "rgba(253, 249, 243, 0.06)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(28px)",

    borderRadius: "0 0 24px 24px", // More rounded for the 'floating' feel
    border: "1px solid rgba(255, 255, 255, 0.4)",
    borderBottom: "1px solid rgba(255, 255, 255, 1)",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
  },

  logo: {
    fontSize: "28px",
    fontWeight: 700,
    backgroundColor: "transparent",
  },

  navLinks: {
    display: "flex",
    gap: "32px",
  },

  // navItem: {
  //   fontSize: "14px",
  //   fontWeight: 700,
  //   cursor: "pointer",
  //   display: "flex",
  //   alignItems: "center",
  //   gap: "4px",
  //   color: "#044c7a",
  // },

  navItem: {
    fontSize: "14px",
    fontWeight: 700,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    textDecoration: "none",

    // Add transition for smooth color swap
    transition: "color 0.3s ease, transform 0.2s ease",

    "&:hover": {
      transform: "translateY(-1px)",
    },
  },

  navActions: {
    display: "flex",
    gap: "16px",
  },

  mobileMenu: {
    width: 260,
    height: "100%",
    display: "flex",
    flexDirection: "column", // 🔥 FIX (vertical)
    padding: "24px",
    gap: "16px",
    backgroundColor: "#ffffff",
  },

  mobileNavItem: {
    fontSize: "16px",
    fontWeight: 600,
    padding: "12px 16px",
    borderRadius: "8px",
    textDecoration: "none",
    color: theme.palette.blue_prime,
    transition: "all 0.2s ease",

    "&:hover": {
      backgroundColor: theme.palette.prime + "14",
    },
  },
});

export default headerStyles;
